import React from "react";
import { PropTypes } from "prop-types";
import { motion } from "framer-motion";

const variants = {
  visible: (itemKey) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.3,
      delay: itemKey * 0.06,
    },
  }),
  hidden: {
    opacity: 0,
    y: 50,
  },
};

const AnimationChildWrapper = ({ children, itemKey }) => {
  return (
    <motion.div
      custom={itemKey}
      variants={variants}
      initial="hidden"
      animate="visible"
    >
      {children}
    </motion.div>
  );
};

AnimationChildWrapper.propTypes = {
  itemKey: PropTypes.number,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

export default AnimationChildWrapper;
